/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the AuthenticationResponse interface.
 */
export function instanceOfAuthenticationResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function AuthenticationResponseFromJSON(json) {
    return AuthenticationResponseFromJSONTyped(json, false);
}
export function AuthenticationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'expiresAt': !exists(json, 'expiresAt') ? undefined : json['expiresAt'],
    };
}
export function AuthenticationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessToken': value.accessToken,
        'expiresAt': value.expiresAt,
    };
}
